import React from "react";
import { Box, Container, Typography } from "@mui/material";
// import webImg from '../assets/images/p5.png';
// import MobImg from '../assets/images/p4.jpg';
// import SoftImg from '../assets/images/p6.jpg';
import p1 from '../assets/images/gst.jpg';
import p2 from '../assets/images/vehtrack.jpg';
import p3 from '../assets/images/fastag.jpg';
import p4 from '../assets/images/finance.jpg';

import FireTruckOutlinedIcon from '@mui/icons-material/FireTruckOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';





const aboutItems = [
   {
    title: "Web Based ERP Solution",
    description: "We help businesses modernize operations through cutting-edge digital solutions. We help businesses modernize operations through cutting-edge digital solutions",
    image: p3,
    color: " #7AB2D3",
    icon: <LanguageOutlinedIcon sx={{ fontSize: 60 }} />,

    // color: 'linear-gradient(to bottom , #7AB2D3, #8ae97d )',

    
  },

  {
    title: "Transport Logistics Software",
    description: "We help in system level configuration for ledgers as per the operational modules. We help businesses modernize operations through cutting-edge digital solutions",
    image: p4,
    color: " #9dd2f1",
    icon: <LocalShippingOutlinedIcon sx={{ fontSize: 60 }} />,

    // color: 'linear-gradient(to bottom , #7AB2D3, #c3e97d )',

    
  },

  {
    title: "Integrated Fleet Management",
    description: "We help in auto account posting from operational module booking, billing, trip advance, hireslip, and vehicle document.We help businesses modernize operations through cutting-edge digital solutions",
    image: p1,
    color: '#7AB2D3',
    icon: <FireTruckOutlinedIcon sx={{ fontSize: 60 }} />,
    // color: 'linear-gradient(to bottom , #7AB2D3, #8ae97d )',
  },

  {
    title: "Financial Accounting ",
    description: "Our experts provide strategic IT guidance to align with your business goals. We help businesses modernize operations through cutting-edge digital solutions",
    image: p2,
    color: " #9dd2f1",
    icon: <ReceiptOutlinedIcon sx={{ fontSize: 60 }} />,
    // color: 'linear-gradient(to bottom , #7AB2D3, #c3e97d )',

  },

  
 
];

export default function AboutSection() {
  return (                                              
                                                        // "#f1f8f6" #8A2BE2 "rgb(194, 215, 228)" 
    <Box sx={{ py: { xs: 8, md: 10 }, background: "linear-gradient(to bottom left, #7AB2D3, #ffffff )" }}>
  
      <Container maxWidth="lg">
          
        <Typography variant="h4" align="center" color="#000" component="h1" gutterBottom sx={{
            fontWeight: 700,
            // textShadow: '1px 1px 4px rgb(122, 178, 211)',
            color: "#ffffff",
            textTransform: "uppercase",
            letterSpacing: 1.5,
            textShadow: '1px 1px 4px rgba(0,0,0,0.4)',
        }}>
          About Us
        </Typography>
        <Typography
          align="center"
          color="#000"
          variant="body1" 
          paragraph
          sx={{  mx: "auto", mb: 6 ,textShadow: '1px 1px 3px rgba(0,0,0,0)' }}
        >
          Claysoft Solutions Pvt. Ltd. is a forward-thinking IT company offering smart, secure, and scalable software solutions. Our flagship Fleet Management Software helps businesses streamline logistics, reduce costs, and gain real-time fleet visibility. We’re committed to making transport operations faster, smarter, and future-ready.
        </Typography>

        {/* Hover expanding section */}
        <Box
          sx={{
            display: "flex",
            overflow: "hidden",
            height: 400,
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          {aboutItems.map((item, index) => (
            <Box
              key={index}
              sx={{
                flex: 1,
                px: 3,
                py: 4,
                position: "relative",
                transition: "flex 0.4s ease",
                background:`${item.color}`,
                // backgroundImage: `url(${item.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "#fff",
              
                "&:hover": {
                  flex: 3,
                 background: 'linear-gradient(to bottom right , #5b58f0, #46e238 )',

                },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textShadow: "1px 1px 4px rgba(0,0,0,0.7)",
                "::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.2)",
                  zIndex: 1,
                },
                zIndex: 0,
              }}
            >

              <Box sx={{ position: "relative", zIndex: 2 }}>

              <Box mb={2} color="#fff" display={'flex'} justifyContent={'center'} >{item.icon}</Box>
 
              <Typography variant="h6" gutterBottom 
              fontFamily={'Merriweather, serif'}
              border={'2px solid white'}
              borderRadius={10}
              padding={0.5}
              paddingLeft={2}
              >
                {item.title}
              </Typography>
              <Typography variant="body2" align="center">
                {item.description}
              </Typography>
            </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}



